import { useEffect, useState } from "react"
import { Status } from "../day/dayView"
import {
  salesContactColors,
  salesContactTooltip,
  salesContactTrafficLight,
  UserCustomerMatrixDTO,
} from "../../DTO/UserCustomerMatrixDTO"
import Spinner from "../../../components/Spinner/Spinner"
import { Box, FormControlLabel, Link, Switch, Tooltip } from "@mui/material"
import mainservice from "../../../services/MainService"
import "./UserCustomerMatrix.scss"

const FIXED_COL_COUNT = 6

export default function UserCustomerMatrix() {
  const [status, setStatus] = useState(Status.loading)
  const [ucm] = useState(new UserCustomerMatrixDTO())
  const [onlyMine, setOnlyMine] = useState(false)
  const [hoverCol, setHoverCol] = useState<number | null>(null)

  async function load(filterMine: boolean) {
    setStatus(Status.loading)
    const uid = mainservice.getUserId()
    ucm.userId = filterMine && uid > 0 ? uid : undefined
    await ucm.getFromServer()
    setStatus(Status.standard)
  }

  useEffect(() => {
    load(false)
  }, [ucm])

  if (status === Status.loading && ucm.customers.length === 0 && !onlyMine) {
    return <Spinner />
  }

  function colClass(colIndex: number) {
    return hoverCol === colIndex ? 'ucm-col-hover' : ''
  }

  return <Box className="UserCustomerMatrix">
    <Box sx={{ padding: 2, paddingBottom: 1 }}>
      <FormControlLabel
        control={
          <Switch
            checked={onlyMine}
            disabled={status === Status.loading}
            onChange={async (_e, checked) => {
              setOnlyMine(checked)
              await load(checked)
            }}
          />
        }
        label="meine Firmen"
      />
    </Box>
    {
      status === Status.loading ? <Spinner /> : <Box className="UserCustomerMatrix-scroll">
      <table className="UserCustomerMatrix-table">
        <thead>
          <tr>
            <th
              className={colClass(0)}
              onMouseEnter={() => setHoverCol(0)}
              onMouseLeave={() => setHoverCol(null)}
              title="Letzter Vertriebskontakt"
            />
            <th
              className={colClass(1)}
              onMouseEnter={() => setHoverCol(1)}
              onMouseLeave={() => setHoverCol(null)}
            />
            <th
              className={`ucm-left ${colClass(2)}`}
              onMouseEnter={() => setHoverCol(2)}
              onMouseLeave={() => setHoverCol(null)}
            >Ort</th>
            <th
              className={colClass(3)}
              title="Training"
              onMouseEnter={() => setHoverCol(3)}
              onMouseLeave={() => setHoverCol(null)}
            >Training</th>
            <th
              className={colClass(4)}
              title="Coaching"
              onMouseEnter={() => setHoverCol(4)}
              onMouseLeave={() => setHoverCol(null)}
            >Coaching</th>
            <th
              className={colClass(5)}
              title="Offenes Training"
              onMouseEnter={() => setHoverCol(5)}
              onMouseLeave={() => setHoverCol(null)}
            >Offenes Training</th>
            {
              ucm.users.map((u, userIndex) => {
                const colIndex = FIXED_COL_COUNT + userIndex
                return <th
                  key={`ucm-header-${u.userId}`}
                  className={`ucm-user-th ${colClass(colIndex)}`}
                  onMouseEnter={() => setHoverCol(colIndex)}
                  onMouseLeave={() => setHoverCol(null)}
                >
                  <Tooltip title={u.userName}>
                    <span>{u.userInitials}</span>
                  </Tooltip>
                </th>
              })
            }
          </tr>
        </thead>
        <tbody>
          {
            ucm.customers.map((c) => {
              const light = salesContactTrafficLight(c.lastSalesContact)
              return <tr key={`ucm-row-${c.id}`}>
                <td
                  className={`ucm-traffic ${colClass(0)}`}
                  onMouseEnter={() => setHoverCol(0)}
                  onMouseLeave={() => setHoverCol(null)}
                >
                  <Tooltip title={salesContactTooltip(c.lastSalesContact)}>
                    <span
                      className="ucm-traffic-dot"
                      style={{ backgroundColor: salesContactColors[light] }}
                    />
                  </Tooltip>
                </td>
                <td
                  className={`ucm-ellipsis ${colClass(1)}`}
                  onMouseEnter={() => setHoverCol(1)}
                  onMouseLeave={() => setHoverCol(null)}
                >
                  <Tooltip title={c.name}>
                    <Link
                      href={`/view=spCustomerEdit/id=${c.id}`}
                      sx={{
                        display: 'block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >{c.name}</Link>
                  </Tooltip>
                </td>
                <td
                  className={colClass(2)}
                  onMouseEnter={() => setHoverCol(2)}
                  onMouseLeave={() => setHoverCol(null)}
                >{c.town || ''}</td>
                <td
                  className={`ucm-number ${colClass(3)}`}
                  onMouseEnter={() => setHoverCol(3)}
                  onMouseLeave={() => setHoverCol(null)}
                >{c.trainingCount || 0}</td>
                <td
                  className={`ucm-number ${colClass(4)}`}
                  onMouseEnter={() => setHoverCol(4)}
                  onMouseLeave={() => setHoverCol(null)}
                >{c.coachingCount || 0}</td>
                <td
                  className={`ucm-number ${colClass(5)}`}
                  onMouseEnter={() => setHoverCol(5)}
                  onMouseLeave={() => setHoverCol(null)}
                >{c.openTrainingCount || 0}</td>
                {
                  ucm.users.map((u, userIndex) => {
                    const match = ucm.userInCustomer(u.userId, c.id)
                    const colIndex = FIXED_COL_COUNT + userIndex
                    return <td
                      key={`ucm-cell-${u.userId}-${c.id}`}
                      className={`ucm-fkt ${match ? 'ucm-fkt-yes' : ''} ${colClass(colIndex)}`}
                      onMouseEnter={() => setHoverCol(colIndex)}
                      onMouseLeave={() => setHoverCol(null)}
                    >{match ? 'X' : ''}</td>
                  })
                }
              </tr>
            })
          }
        </tbody>
      </table>
    </Box>
    }
  </Box>
}

